function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["id", "realm"],
  _excluded2 = ["id", "realm"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* eslint consistent-return: 0 */
import { isString } from './utils';
export function sdrn(id) {
  var realm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'schibsted.com';
  return "sdrn:".concat(realm, ":user:").concat(id);
}

/**
 * Test
 */

function formatActorInput(input) {
  if (isString(input)) {
    return {
      id: input
    };
  }
  var _ref = input || {},
    id = _ref.id,
    realm = _ref.realm,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread({
    id: id,
    realm: realm
  }, rest);
}

/**
 * Function to generate a builder for Actor objects.
 *
 */
export default function actor(builderInput) {
  var _ref2 = builderInput || {},
    actorData = _ref2.actor;
  var _formatActorInput = formatActorInput(actorData),
    id = _formatActorInput.id,
    realm = _formatActorInput.realm,
    props = _objectWithoutProperties(_formatActorInput, _excluded2);
  if (!id) {
    return undefined;
  }
  return Object.assign({
    '@id': sdrn(id, realm),
    'spt:userId': sdrn(id, realm)
  }, props);
}
export function defaultValue() {}